import styled from "styled-components";

const MaxWidth = styled.div`
display: block;
max-width: 80rem;
margin: 0 auto;
`

export default MaxWidth
